<div class="input-card">
  @if (label()) {
  <label class="floating-label" [for]="name() || label()">{{ label() }}</label>
  }

  <div
    class="floating-wrapper"
    [class.is-textarea]="isTextarea()"
    [class.is-range]="isRange()"
    [class.is-color]="isColor()"
    [class.no-icon]="noIcon()"
  >
    <!-- ── Icône contextuelle (masquée pour range / color / file) ─────────── -->
    @if (!noIcon() && !isRange() && !isColor() && !isFile()) {
    <span
      class="input-icon"
      [class.input-icon--textarea]="isTextarea()"
      aria-hidden="true"
    >
      <!-- text / search -->
      @if (type() === 'text' || type() === 'search') {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      }

      <!-- number (affiché même quand thousandSeparator transforme en type=text) -->
      @if (type() === 'number') {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <line
          x1="4"
          y1="9"
          x2="20"
          y2="9"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="4"
          y1="15"
          x2="20"
          y2="15"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="10"
          y1="3"
          x2="8"
          y2="21"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="16"
          y1="3"
          x2="14"
          y2="21"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      }

      <!-- email -->
      @if (type() === 'email') {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <circle
          cx="12"
          cy="12"
          r="4"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <path
          d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      }

      <!-- password -->
      @if (type() === 'password') {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <rect
          x="3"
          y="11"
          width="18"
          height="11"
          rx="2"
          ry="2"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <path
          d="M7 11V7a5 5 0 0 1 10 0v4"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      }

      <!-- tel -->
      @if (type() === 'tel') {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.64 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.12 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L9.91 9.91a16 16 0 0 0 6 6l.38-.38a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      }

      <!-- url -->
      @if (type() === 'url') {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      }

      <!-- date / datetime-local / month / week -->
      @if (type() === 'date' || type() === 'datetime-local' || type() ===
      'month' || type() === 'week') {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <rect
          x="3"
          y="4"
          width="18"
          height="18"
          rx="2"
          ry="2"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <line
          x1="16"
          y1="2"
          x2="16"
          y2="6"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="8"
          y1="2"
          x2="8"
          y2="6"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="3"
          y1="10"
          x2="21"
          y2="10"
          stroke="currentColor"
          stroke-width="1.5"
        />
      </svg>
      }

      <!-- time -->
      @if (type() === 'time') {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <polyline
          points="12 6 12 12 16 14"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      }

      <!-- textarea -->
      @if (isTextarea()) {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <line
          x1="3"
          y1="6"
          x2="21"
          y2="6"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="3"
          y1="12"
          x2="21"
          y2="12"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="3"
          y1="18"
          x2="15"
          y2="18"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      }

      <!-- fallback -->
      @if ( !isTextarea() &&
      !['text','search','number','email','password','tel','url',
      'date','datetime-local','month','week','time'].includes(type()) ) {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      }
    </span>
    }<!-- /icône -->

    <!-- ══════════════════════════════════════════════════════════════════════
         CAS 1 — TEXTAREA
    ══════════════════════════════════════════════════════════════════════ -->
    @if (isTextarea()) {
    <textarea
      [id]="name() || label()"
      [name]="name()"
      [value]="displayValue"
      [placeholder]="placeholder()"
      [disabled]="isDisabled"
      [rows]="rows()"
      [attr.autocomplete]="autocomplete()"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      class="input-root input-textarea"
      [attr.aria-label]="label()"
    ></textarea>
    }

    <!-- ══════════════════════════════════════════════════════════════════════
         CAS 2 — COLOR PICKER
    ══════════════════════════════════════════════════════════════════════ -->
    @if (isColor()) {
    <div class="color-wrapper">
      <input
        type="color"
        [id]="name() || label()"
        [name]="name()"
        [value]="displayValue || '#000000'"
        [disabled]="isDisabled"
        (input)="onInputChange($event)"
        (blur)="onBlur()"
        class="input-root input-color"
        [attr.aria-label]="label()"
      />
      <span class="color-hex">{{ displayValue || '#000000' }}</span>
    </div>
    }

    <!-- ══════════════════════════════════════════════════════════════════════
         CAS 3 — RANGE SLIDER
    ══════════════════════════════════════════════════════════════════════ -->
    @if (isRange()) {
    <div class="range-wrapper">
      <input
        type="range"
        [id]="name() || label()"
        [name]="name()"
        [value]="displayValue || '0'"
        [disabled]="isDisabled"
        [attr.min]="min()"
        [attr.max]="max()"
        [attr.step]="step()"
        (input)="onInputChange($event)"
        (blur)="onBlur()"
        class="input-root input-range"
        [attr.aria-label]="label()"
      />
      <span class="range-value">{{ displayValue }}</span>
    </div>
    }

    <!-- ══════════════════════════════════════════════════════════════════════
         CAS 4 — FILE
    ══════════════════════════════════════════════════════════════════════ -->
    @if (isFile()) {
    <label class="file-label" [for]="name() || label()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <polyline
          points="17 8 12 3 7 8"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line
          x1="12"
          y1="3"
          x2="12"
          y2="15"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      <span>{{ placeholder() || 'Choisir un fichier' }}</span>
      <input
        type="file"
        [id]="name() || label()"
        [name]="name()"
        [disabled]="isDisabled"
        [attr.accept]="accept()"
        [multiple]="multiple()"
        (change)="onInputChange($event)"
        (blur)="onBlur()"
        class="input-file-hidden"
        [attr.aria-label]="label()"
      />
    </label>
    }

    <!-- ══════════════════════════════════════════════════════════════════════
         CAS 5 — TOUS LES AUTRES TYPES (text, number, email, date, etc.)
         NOTE : on crée UN SEUL nœud <input> avec [type]="effectiveType()"
                effectiveType() retourne "text" si thousandSeparator + number,
                ce qui évite toute restriction native du navigateur sur type="number".
    ══════════════════════════════════════════════════════════════════════ -->
    @if (!isTextarea() && !isColor() && !isRange() && !isFile()) {
    <input
      [type]="effectiveType()"
      [id]="name() || label()"
      [name]="name()"
      [value]="displayValue"
      [placeholder]="placeholder()"
      [disabled]="isDisabled"
      [attr.min]="(type() === 'number' || type() === 'date' || type() === 'time') ? min() : null"
      [attr.max]="(type() === 'number' || type() === 'date' || type() === 'time') ? max() : null"
      [attr.step]="type() === 'number' ? step() : null"
      [attr.autocomplete]="autocomplete()"
      [attr.multiple]="type() === 'email' && multiple() ? true : null"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      class="input-root"
      [class.input-date]="type() === 'date' || type() === 'datetime-local' || type() === 'month' || type() === 'week'"
      [class.input-time]="type() === 'time'"
      [attr.aria-label]="label()"
    />
    }

    <span class="input-state" aria-hidden="true"></span>
  </div>
</div>
